import { en } from './en.js'
import { novelPt } from './novel-pt.js'
import { novelComparisonPt } from './novel-comparison.js'
import { novelShellPt, withNovelShell } from './novel-shell.js'

export const pt = structuredClone(en)

pt.visualGameAdmin.conversionFunnelDevices = {'label': 'Dispositivos de origem', 'all': 'Todos', 'desktop': 'Computador', 'mobile': 'Celular', 'tablet': 'Tablet'}

pt.visualGameAdmin.pageFunnel = {'button': 'Ver funil de páginas', 'title': 'Funil de páginas', 'home': 'Início', 'auth': 'Entrada ou cadastro', 'game': 'Página de jogo', 'note': 'Sessões que percorrem as etapas na ordem, por data e dispositivo. Inclui o diálogo de login no PC. Aberturas históricas sem registro não podem ser recuperadas.', 'loading': 'Carregando…', 'error': 'Falha ao carregar', 'sessions': 'sessões'}

pt.visualGameAdmin.pageFunnel.viewUsers = 'Ver usuários'
pt.visualGameAdmin.pageFunnel.peopleUnit = 'usuários'
pt.visualGameAdmin.pageFunnel.timesUnit = 'vezes'

pt.visualGameAdmin.pageFunnel.userFilter_all = 'Funil: cadastros ou logins'

pt.visualGameAdmin.pageFunnel.userFilter_sign_up = 'Funil: cadastros no período'

pt.visualGameAdmin.pageFunnel.userFilter_login = 'Funil: logins no período'

pt.visualGameAdmin.usageActivity = {
  "title": "Uso do site · Atividade",
  "button": "Ver detalhes",
  "all": "Todas as atividades",
  "search": "Buscar usuário, jogo ou ID",
  "user": "Usuário",
  "game": "Jogo",
  "kind": "Atividade",
  "status": "Estado",
  "time": "Data",
  "detail": "Ver registro",
  "empty": "Nenhum registro encontrado",
  "loading": "Carregando…",
  "error": "Falha ao carregar",
  "note": "As entradas usam eventos próprios e podem diferir do GA4. Textos e partidas não registrados não são inferidos.",
  "limit": "Últimos 1000 registros. Reduza o período para ver outros.",
  "text_input": "Entrada de texto",
  "voice_input": "Entrada de voz",
  "slice_video": "Geração de clipe",
  "global_video": "Geração de vídeo completo",
  "free_game": "Geração de jogo grátis"
}

Object.assign(pt.visualGameAdmin.usageActivity, {
  "status_queued": "Na fila",
  "status_running": "Em andamento",
  "status_ready": "Concluído",
  "status_failed": "Falhou",
  "status_submitting": "Enviando",
  "status_submitted": "Enviado",
  "status_ok": "Sucesso",
  "status_error": "Falhou",
  "status_generating": "Gerando",
  "status_generation_failed": "Falha na geração",
  "status_pending_review": "Em revisão",
  "status_review_rejected": "Rejeitado",
  "status_published": "Publicado",
  "status_archived": "Arquivado"
})

pt.visualGameAdmin.usageActivity.records = 'registros'

pt.visualGameAdmin.paypointActivity = {
  "title": "Pontos de pagamento · Detalhes",
  "all": "Todos",
  "game": "Página",
  "kind": "Contexto",
  "status": "Motivo",
  "note": "Eventos próprios podem diferir do GA4. Abrir o diálogo de vídeo não indica saldo insuficiente. Registros históricos não incluem saldo, custo ou ID da partida.",
  "billing_paypoint_gameplay": "Jogo",
  "billing_paypoint_ending_video": "Vídeo final",
  "billing_paypoint_story_video": "Vídeo da história",
  "status_insufficient_balance": "Créditos insuficientes",
  "status_dialog_open": "Diálogo de geração aberto"
}

pt.visualGameAdmin.paypointActivity.search = 'Buscar usuário, página ou ID'

pt.visualGameAdmin.orderDrilldown = {
  "button": "Ver pedidos",
  "dateField": "Referência de data",
  "created_at": "Data de criação",
  "paid_at": "Data de pagamento"
}

Object.assign(pt.visualGameAdmin.orderDrilldown, {
  "since": "Data inicial",
  "until": "Data final"
})

pt.visualGameAdmin.orderDrilldown.updated_at = 'Data de atualização do status'

pt.visualGameAdmin.trafficBaseline = {
  "confirmed": "Aumento confirmado",
  "first": "Visualizações da primeira recolha (sem referência histórica)",
  "missing": "Sem referência; aumento incompleto",
  "note": "Vídeos publicados no intervalo começam em zero e incluem a primeira recolha no aumento. Para vídeos anteriores ou sem data de publicação e sem registo prévio, a primeira recolha é apresentada separadamente. A data de recolha não é a de publicação.",
  "observed": "Primeira observação",
  "filter": "Sem referência",
  "unchanged": "Sem aumento (referência completa)",
  "later": "Aumento após primeira observação"
}

pt.visualGameAdmin.funnelAuth = {
  registration: 'Cadastros no site',
  login: 'Logins no site',
  new_users: 'Logins de novos usuários',
  existing_users: 'Logins de usuários existentes',
  note: 'Novos usuários se cadastraram no período selecionado; antigos, antes. O login inclui o acesso automático após cadastro. Usuários são contados sem duplicação; acessos incluem o login automático e os seguintes. Cadastro e login se sobrepõem e não devem ser somados.',
  user_type: 'Tipo de usuário',
  registered_at: 'Data de cadastro',
  new_type: 'Novo usuário',
  existing_type: 'Usuário existente',
  auto_login: 'Login automático após cadastro'
}

pt.visualGameAdmin.funnelPeriods = {
  yesterday: 'Ontem',
  last_three_days: 'Últimos 3 dias'
}

pt.visualGameAdmin.videoExport = {
  button: 'Exportar lista atual CSV',
  published_sort: 'Por data de publicação',
  published_label: 'Publicado em',
  unknown: 'Não registrado'
}

withNovelShell(pt.visualGameAdmin, novelShellPt)
Object.assign(pt.visualGameAdmin, novelPt, { novelComparison: novelComparisonPt })

pt.visualGameAdmin.storyFilmPromptReview = {
      title: 'Revisão de prompts do drama',
      subtitle: 'Revisão de conteúdo dos prompts finais por plano e parâmetros. Aprovar o conteúdo não é chamar o H3 nem deixa um vídeo reproduzível.',
      gateNotice: 'A aprovação cobre apenas prompt e plano. As chamadas H3 do fornecedor continuam sob um controle separado de orçamento/limite; hoje não autorizadas e sem botão de chamada.',
      loading: 'Carregando…',
      empty: 'Nenhum pacote ainda',
      filters: {
      status: 'Status da revisão',
      all: 'Todos',
      owner: 'Jogador (owner)',
      ownerPlaceholder: 'user id',
      run: 'Partida',
      runPlaceholder: 'run_id',
      branch: 'Ramo',
      branchPlaceholder: 'branch_id',
      season: 'Temporada',
      seasonPlaceholder: 'season_id',
      episode: 'Episódio',
      episodePlaceholder: 'episode_id',
      planDigest: 'Versão do plano',
      planDigestPlaceholder: 'plan_digest',
      version: 'Versão do pacote',
      versionPlaceholder: 'n.º da versão',
    },
      actions: {
      search: 'Buscar',
      clear: 'Limpar filtros',
      view: 'Ver',
      more: 'Carregar mais',
      approve: 'Aprovar conteúdo',
      reject: 'Devolver para revisão',
      rejectPlaceholder: 'Motivo (obrigatório)',
      regenerate: 'Nova versão',
      simulatedNotification: 'Ver notificações simuladas',
    },
      validation: {
      limit: '{count}/{max} caracteres (sem espaços nas extremidades)',
      required: 'Informe um motivo antes de devolver o pacote.',
      too_long: 'O motivo aceita até {max} caracteres. Encurte antes de enviar; o pacote não foi devolvido.',
      invalid_body: 'O motivo não foi aceito. Confira o texto: {message}',
    },
      notice: {
      approve: 'Conteúdo aprovado; sem chamada H3 e sem cobrança.',
      reject: 'Devolvido com motivo registrado.',
      regenerate: 'Nova versão criada; revise novamente.',
    },
      columns: {
      episode: 'Episódio',
      version: 'Versão',
      status: 'Status',
      shots: 'Planos',
      duration: 'Duração',
      digest: 'Resumo do pacote',
      createdAt: 'Criado',
    },
      status: {
      draft: 'Aguardando',
      in_review: 'Em revisão',
      approved: 'Aprovado',
      rejected: 'Devolvido',
      superseded: 'Substituído',
    },
      detail: {
      title: 'Pacote #{id} · v{version}',
      owner: 'Jogador',
      film: 'Obra',
      season: 'Temporada',
      episode: 'Episódio',
      run: 'Partida',
      branch: 'Ramo',
      range: 'Intervalo de turnos',
      sourceVersion: 'Versão de origem',
      snapshot: 'Instantâneo',
      planDigest: 'Resumo do plano',
      packDigest: 'Resumo do pacote',
      planVersion: 'Versão pacote/plano',
      cutPolicy: 'Versão da política de corte',
      costModel: 'Versão do modelo de custo',
      gate: 'Controles',
      gateValue: 'Orçamento={budget} · modelo de custo={cost} · pontos previstos={points} · suporte a prompt negativo={negative}',
      provider: 'Fornecedor',
      providerValue: '{provider} / {model} · {size} · steps={steps} · turbo={turbo} · fila={priority} · {shots} planos',
      shotsTitle: 'Pacote por plano',
      chars: '{count} caracteres',
      sendable: 'Enviável',
      notSendable: 'Não enviável',
      blocked: 'Motivos de bloqueio',
      promptTitle: 'Prompt positivo final',
      requestTitle: 'Parâmetros da solicitação (apenas campos verificados)',
      evidenceTitle: 'Evidência de origem (visível ao jogador)',
      anchorsTitle: 'Âncoras de personagem/cena',
      speakers: 'Personagens',
      locations: 'Cenas',
      references: 'Materiais de referência',
      negativeTitle: 'Prompt negativo (revisão de conteúdo; campo do fornecedor não verificado)',
      negativeGate: 'O prompt negativo não faz parte da solicitação enviável: o adaptador H3 atual não verifica esse campo.',
      episodeSummary: 'Planos {shots} · duração {duration}ms · quadros {frames} · quantização {frameMs}ms · teto total {caps}ms',
      quoteSummary: 'Instantâneo da cotação: {status} · pontos previstos {points} · coeficiente {ppm}ppm · {currency}',
      cost: 'Custo previsto: {points}',
      costUnapproved: 'não aprovado',
    },
      events: {
      title: 'Histórico de revisão',
    },
    }

pt.visualGameAdmin.storyFilmPromptReview.simulatedPage = {
      title: 'Prévia de notificações simuladas',
      subtitle: 'Revisão com carga simulada fixa; sem leituras/escritas no banco, e-mails ou cobranças.',
      isolation: 'Esta página é isolada do ready outbox real, mídia, estado de primeira gratuidade e SMTP; sem reprodução ou reembolso reais.',
      back: 'Voltar à revisão de prompts',
    }
pt.visualGameAdmin.storyFilmPromptReview.detail.trim = 'plano {plan}ms / gera {gen}ms (corta o excesso)'

pt.visualGameAdmin.storyFilmPromptReview.detail.providerValue = '{provider} / {model} · {size} · {aspect} · móvel {fit} · capacidade {capability} · steps={steps} · turbo={turbo} · fila={priority} · {shots} planos'

pt.visualGameAdmin.storyFilmPromptReview.detail.episodeSummary = 'Planos {shots} · plano {duration}ms · quadros {frames} · quantização {frameMs}ms · teto total {caps}ms · H3 {h3fps}fps'
pt.visualGameAdmin.storyFilmPromptReview.detail.selection = 'Contrato de seleção A'

pt.visualGameAdmin.storyFilmPromptReview.detail.selectionValue = '{status} · {version} · {units} unidades · omitidos {omitted} caracteres · {digest}'
pt.visualGameAdmin.storyFilmPromptReview.detail.selectionArc = 'Evidência de fechamento settlement={settlement} · ending={ending} · opening={opening} · climax={climax} · resolution={resolution}'
pt.visualGameAdmin.storyFilmPromptReview.detail.generation = 'Corte final {final}ms / geração {gen}ms / cap {cap}ms'

pt.visualGameAdmin.storyFilmPromptReview.detail.capExceeded = 'A geração excede o cap em {over}ms; não enviável'

pt.visualGameAdmin.storyFilmPromptReview.detail.durationSplit = 'Final {final}ms / geração {gen}ms / cap {cap}ms / planos excedidos {exceeded}'
